module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data"
  }, [_c('div', {
    staticClass: "school-data__header"
  }, [_c('div', {
    staticClass: "school-data__header__left"
  }, [_c('h1', [_vm._v("Skemalagte timer")]), _vm._v(" "), _c('changeSchoolYear', {
    staticClass: "marg-1-right",
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "school-data__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [(_vm.filteredCalendars.length < 1) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen klasser i skoleåret")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.filteredCalendars), function(calendar) {
    return _c('li', {
      key: calendar.id
    }, [_c('SchoolDataGrade', {
      attrs: {
        "calendar": calendar,
        "eventsInHash": _vm.eventsInHash
      }
    })], 1)
  }), 0)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7e207f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolData.vue
// module id = 2151
// module chunks = 1